/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsFormComponent } from './clients/clients-form/clients-form.component';
import { ClientsListComponent } from './clients/clients-list/clients-list.component';
import { ClientsRoutingModule } from '@app/clients/clients-routing.module';
import { SharedModule } from '@app/shared';
import { ClientsService } from '@app/clients/clients/clients.service';
import { ClientsFormService } from '@app/clients/clients/clients-form.service';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { ClientsViewComponent } from './clients/clients-view/clients-view.component';

@NgModule({
  declarations: [ClientsFormComponent, ClientsListComponent, ClientsViewComponent],
  imports: [CommonModule, ClientsRoutingModule, SharedModule],
  providers: [ClientsService, ClientsFormService, KendoGridService],
})
export class ClientsModule {}
